import React, { useState, useEffect } from 'react';
import {
  Paper,
  TextField,
  InputAdornment,
  Tooltip,
  IconButton,
} from '@material-ui/core';
import useStyle from './useStyle';
import reload from '../../assets/img/iconos/reload.svg';
import { categoryOptions } from './components/constants';
import { Loading } from '../../components';
import BannerTable from './components/DataTable/BannerTable.readonly';
import newButton from '../../assets/img/iconos/newButton.svg';
import searchIcon from '../../assets/img/iconos/searchIcon.svg';
import ActionForm from './components/ActionForm/ActionForm.readonly';
import {
  getBannersService,
  getPromotionsApp,
} from '../../services';
import useScreensAppPersonas from '../../services/banners/useScreensAppPersonas';

const BannersScreen = () => {
  const classes = useStyle();
  const [banners, setBanners] = useState([]);
  const [promos, setPromos] = useState([]);
  const [screens, setScreens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [enteredFilter, setEnteredFilter] = useState('');
  const defaultData = {
    name: '',
    description: '',
    category: categoryOptions[0].value,
    target: '',
    promotion: '',
    redirection: 'promotionScreen/',
    order: '0',
    startDate: '',
    endDate: '',
  };
  const [defaultValues, setDefaultValues] = useState(defaultData);
  const [popUpAction, setPopUpAction] = useState({ open: false, title: '', data: null });

  const { data: screenData, error: screenError } = useScreensAppPersonas();

  const getBanners = async () => {
    const res = await getBannersService();
    if (res.data?.length > 0) {
      const dataOrder = res.data.sort((a, b) => (a.order > b.order ? -1 : 0));
      return setBanners(dataOrder);
    }
    return setBanners([]);
  };

  const getPromotions = async () => {
    const res = await getPromotionsApp();
    const filterActive =
      res.length > 0
        ? res
            .filter((promo) => promo.status === 'activo')
            .map((item) => ({
              value: `${item.id}`,
              label: item.promotionName,
              extraData: { startDate: item.startDate, endDate: item.endDate },
            }))
        : res;
    return setPromos(filterActive);
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      await Promise.all([getBanners(), getPromotions()]);
      setLoading(false);
    };

    loadData();
  }, []);

  useEffect(() => {
    if (screenData?.length > 0) {
      const filterActive = screenData.map((item) => ({
        value: item.value,
        label: item.key.replace(/_/g, ' '),
      }));
      setScreens(filterActive);
    }
  }, [screenData]);

  return (
    <Paper className={classes.paper}>
      <>
        {loading && <Loading />}
        <div className={classes.root}>
          <div>
            <TextField
              className={classes.searchTextField}
              value={enteredFilter}
              onChange={(e) => setEnteredFilter(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={searchIcon} alt="searchIcon" style={{ paddingLeft: '10px' }} />
                  </InputAdornment>
                ),
                disableUnderline: true,
              }}
              placeholder="Buscar"
            />
            <Tooltip title="Refrescar página" aria-label="Refrescar página">
              <IconButton
                onClick={getBanners}
                style={{ fontSize: '20px', float: 'right' }}
                edge="end"
                size="small"
              >
                <img src={reload} alt="reload" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Crear banner" aria-label="Nuevo banner">
              <IconButton
                style={{ fontSize: '20px', float: 'right' }}
                edge="end"
                size="small"
                disabled
              >
                <img src={newButton} alt="newButton" className={classes.imgColorReadOnly} />
              </IconButton>
            </Tooltip>
          </div>
          <BannerTable
            banners={banners}
            enteredFilter={enteredFilter}
            setDefaultValues={setDefaultValues}
            setPopUpAction={setPopUpAction}
          />
          <ActionForm
            open={popUpAction.open}
            data={popUpAction.data}
            title={popUpAction.title}
            defaultValues={defaultValues}
            setDefaultValues={setDefaultValues}
            banners={banners}
            promotions={promos}
            screens={screens}
            onClose={() =>
              setPopUpAction({ open: false, title: '', data: null })
            }
          />
        </div>
      </>
    </Paper>
  );
};

export default BannersScreen;